module.exports = __webpack_public_path__ + "static/media/logo.6a1b6c74.png";